var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Wallet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 7.86584045 0 7.86584045 5.99931334 0 5.99931334"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 19.9998 0 19.9998 19.2242605 0 19.2242605"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Wallet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(12.133960, 8.091764)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53397822,4.66731778 L2.99999,4.66731778 C2.08065973,4.66731778 1.33199556,3.91932027 1.33199556,2.99999 C1.33199556,2.08065973 2.08065973,1.33199556 2.99999,1.33199556 L6.53397822,1.33199556 L6.53397822,4.66731778 Z M2.99999,0 C1.34599551,0 0,1.34532885 0,2.99999 C0,4.65398449 1.34599551,5.99931334 2.99999,5.99931334 L7.86597378,5.99931334 L7.86597378,0 L2.99999,0 Z",
    id: "Fill-1",
    fill: "#282828"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.4681518,11.0916876 C14.4681518,11.4596864 14.7661508,11.7576854 15.1341496,11.7576854 L15.3208156,11.7576854 C15.6888144,11.7576854 15.9868134,11.4596864 15.9868134,11.0916876 C15.9868134,10.7236888 15.6888144,10.4256898 15.3208156,10.4256898 L15.1341496,10.4256898 C14.7661508,10.4256898 14.4681518,10.7236888 14.4681518,11.0916876",
    id: "Fill-4",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6679378,15.5762727 C18.6679378,16.8536017 17.6292746,17.8929316 16.3519455,17.8929316 L3.64798784,17.8929316 C2.37065876,17.8929316 1.33199556,16.8536017 1.33199556,15.5762727 L1.33199556,10.1576241 L1.33199556,6.96163472 C1.33199556,6.47896966 1.4213286,6.01363788 1.58266139,5.57963932 C1.96266012,4.81897519 2.7413242,4.28964362 3.64798784,4.28964362 L16.3519455,4.28964362 C17.6292746,4.28964362 18.6679378,5.32897349 18.6679378,6.60630257 L18.6679378,15.5762727 Z M12.5539582,1.38965329 C13.3719554,1.22165385 14.207286,1.42765316 14.8532838,1.95365141 C15.1899494,2.22831716 15.4466152,2.57364934 15.6199479,2.95831473 L4.93731688,2.95831473 L12.5539582,1.38965329 Z M17.0546098,3.02764783 C16.8346106,2.20898389 16.3686121,1.47098635 15.6946144,0.920988187 C14.7372842,0.140990787 13.4952883,-0.164341529 12.2852924,0.0849909737 L4.25731914,1.7383188 C2.48599171,2.10298425 1.06732978,3.34098012 0.405998647,4.94164145 C0.147999507,5.44097312 0,6.00630457 0,6.60630257 L0,6.96163472 L0,10.1576241 L0,15.5762727 C0,17.5875993 1.63666121,19.2242605 3.64798784,19.2242605 L16.3519455,19.2242605 C18.3632721,19.2242605 19.9999333,17.5875993 19.9999333,15.5762727 L19.9999333,6.60630257 C19.9999333,4.8356418 18.7306042,3.3563134 17.0546098,3.02764783 L17.0546098,3.02764783 Z",
    id: "Fill-6",
    fill: "#282828"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.99983333,15.0242078 L4.399852,15.0242078 C4.03185323,15.0242078 3.73385422,14.7262088 3.73385422,14.3582101 C3.73385422,13.9902113 4.03185323,13.6922123 4.399852,13.6922123 L9.99983333,13.6922123 C10.3678321,13.6922123 10.6658311,13.9902113 10.6658311,14.3582101 C10.6658311,14.7262088 10.3678321,15.0242078 9.99983333,15.0242078",
    id: "Fill-9",
    fill: "#282828"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.8f1c67a5a51b94ff2e7c33cd1e41cda5.svg";
export { ForwardRef as ReactComponent };